import apple from "../assets/svg/apple.svg";
import google from "../assets/svg/google.svg";
import back from "../assets/svg/back.svg";
import bgSmall from "../assets/images/bgSmall.png";
import bgLarge from "../assets/images/bgLarge.png";
import download from "@/assets/images/download.png";
import wanderSmall from "@/assets/images/wander.png";
import wanderLarge from "@/assets/images/wanderLarge.png";
import landing from "@/assets/images/landing/landing1.jpg";
import landing2 from "@/assets/images/landing/landing2.jpg";
import AI from "@/assets/images/landing/AI.png";
import AI2 from "@/assets/images/landing/AI2.png";
import download1 from "@/assets/images/landing/download.png";
import download2 from "@/assets/images/landing/download_inverted.png";
import eye from "@/assets/images/landing/eye.png";
import eyes from "@/assets/images/landing/eyes.png";
import dayjs from "dayjs";

export const appleSvg = apple;
export const googleSvg = google;
export const backSvg = back;
export const bgSmallImage = bgSmall;
export const bgLargeImage = bgLarge;
export const downloadImage = download;
export const wanderSmallImage = wanderSmall;
export const wanderLargeImage = wanderLarge;
export const landingImage = landing;
export const landing2Image = landing2;
export const AIImage = AI;
export const AI2Image = AI2;
export const download1Image = download1;
export const download2Image = download2;
export const eyeImage = eye;
export const eyeImage2 = eyes;
export const timeFormat = (time) => {
  return dayjs(time).format("YYYY-MM-DD HH:mm:ss");
};
export const timeFormatDate = (time) => {
  return dayjs(time).format("YYYY-MM-DD");
};
